import {
	Component,
	EventEmitter,
	Input,
	Output
} from "@angular/core";

@Component({
	selector: 'cp-popup-buttons-ok-checkbox-cancel',
	template : `
		<cp-button-strip>
			<div class="primary-area">
                <cp-checkbox [(ngModel)]="isCheck"
							[disabled]="okDisabled"
							[label]="checkboxLabel | cpLabelTranslate"
                            (ngModelChange)="checked.emit($event)">
                </cp-checkbox>  
				<cp-button-widget-custom class="primary-button"
					[cpFocus]="focusOnOK"
					[cpFocusOnChanges]="true"
					[titleToTranslate]="okLabel ? okLabel : 'OK'"
					[isDisabled]="okDisabled" [tooltipPlain]="okTooltipPlain"
					(onClick)="okDisabled ? null : ok.emit();">
				</cp-button-widget-custom>  
			</div>
			<div class="secondary-area">
				<cp-button-widget-custom class="tertiary-button"
					[titleToTranslate]="cancelLabel ? cancelLabel : 'Cancel'"
					(onClick)="cancel.emit();">
				</cp-button-widget-custom>
			</div>
		</cp-button-strip>
`
})
export class PopupButtonsOkWithCheckBoxCancelComponent {

	@Input() okLabel: string;
	@Input() cancelLabel: string;
	@Input() okDisabled: boolean;
	@Input() okTooltipPlain : string;
	@Input() focusOnOK:boolean;
    @Input() checkboxLabel:string;

	@Output() ok = new EventEmitter();
	@Output() cancel = new EventEmitter();
    @Output() checked = new EventEmitter<boolean>();

    public isCheck: boolean;
}
